export interface ChartPoint { label: string; value: number; }

export function AreaChart({ points, height = 160, color = 'var(--brand-green)' }: { points: ChartPoint[]; height?: number; color?: string }) {
  const w = 600;
  const h = height;
  const pad = 24;
  if (points.length === 0) return <div style={{ height, display: 'grid', placeItems: 'center', color: 'var(--text-hint)' }}>Sin datos</div>;
  const max = Math.max(1, ...points.map((p) => p.value));
  const step = points.length > 1 ? (w - pad * 2) / (points.length - 1) : 0;
  const x = (i: number) => pad + i * step;
  const y = (v: number) => h - pad - (v / max) * (h - pad * 2);
  const line = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${x(i)} ${y(p.value)}`).join(' ');
  const area = `${line} L ${x(points.length - 1)} ${h - pad} L ${x(0)} ${h - pad} Z`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" height={h} preserveAspectRatio="none" role="img" aria-label="Gráfica de ingresos">
      <path d={area} fill={color} opacity={0.15} />
      <path d={line} fill="none" stroke={color} strokeWidth={2.5} />
      {points.map((p, i) => (
        <g key={p.label}>
          <circle cx={x(i)} cy={y(p.value)} r={3} fill={color} />
          <text x={x(i)} y={h - 6} fontSize={10} fill="var(--text-hint)" textAnchor="middle">{p.label}</text>
        </g>
      ))}
    </svg>
  );
}
